(() => {
  const targetClass = 'ferret2';
  const targetId = 'trustmate-section';
  const handledAttribute = 'data-trustmate-handled';
  const carouselSelectors = '.tm-carousel, .tm-carousel-wrapper, .tm-carousel__track';

  const applyCarouselStyles = () => {
    const destination = document.getElementById(targetId);

    if (!destination) {
      return;
    }

    destination.querySelectorAll(carouselSelectors).forEach((element) => {
      element.style.setProperty('overscroll-behavior-x', 'none');
      element.style.setProperty('overscroll-behavior-y', 'none');
      element.style.setProperty('touch-action', 'pan-y');
    });
  };

  const handleElement = (element) => {
    if (!(element instanceof Element)) {
      return;
    }

    if (element.hasAttribute(handledAttribute)) {
      return;
    }

    element.setAttribute(handledAttribute, 'true');
    element.style.setProperty('margin', '16px 0')
    element.style.setProperty('overscroll-behavior-x', 'none', 'important');
    element.style.setProperty('overscroll-behavior-y', 'none', 'important');
    const destination = document.getElementById(targetId);

    if (destination) {
      destination.appendChild(element);
      applyCarouselStyles();
      return;
    }

    element.remove();
  };

  const scanAndHandle = () => {
    document.querySelectorAll(`.${targetClass}`).forEach(handleElement);
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) {
          return;
        }

        if (node.matches(`.${targetClass}`)) {
          handleElement(node);
        }

        node.querySelectorAll(`.${targetClass}`).forEach(handleElement);
      });
    });
  });

  const startObserver = () => {
    scanAndHandle();
    applyCarouselStyles();

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }

    const destination = document.getElementById(targetId);

    if (destination) {
      const destinationObserver = new MutationObserver(applyCarouselStyles);
      destinationObserver.observe(destination, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
